var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    [
      _c("button", { staticClass: "btn-reset", on: { click: _vm.reset } }, [
        _vm._v("reset")
      ]),
      _vm._v(" "),
      _vm.items.length
        ? _c("InfiniteScroll", {
            attrs: {
              direction: "up",
              auto: "in-viewport",
              head: _vm.items[0] && _vm.items[0].id,
              next: _vm.prev,
              handler: _vm.loadPrevPage
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        _vm._l(_vm.items, function(item) {
          return _c(
            "li",
            {
              key: item.id,
              style: { background: "hsl(" + item.color.join() + ")" },
              attrs: { "data-inf-id": item.id }
            },
            [_vm._v("\n      " + _vm._s(item.id) + "\n    ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("InfiniteScroll", {
        attrs: {
          head: _vm.items.length,
          next: _vm.next,
          handler: _vm.loadNextPage
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }